module.exports = __webpack_public_path__ + "img/dice-gray.31b0ff6b.png";